import { render, staticRenderFns } from "./AmountIndicator.vue?vue&type=template&id=5dc87338"
import script from "./AmountIndicator.vue?vue&type=script&lang=ts"
export * from "./AmountIndicator.vue?vue&type=script&lang=ts"
import style0 from "./AmountIndicator.vue?vue&type=style&index=0&id=5dc87338&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports